module.exports = __webpack_public_path__ + "img/emploisrh.fd4401b3.png";